import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { FormInput } from '../components/FormControls.jsx';
import { PortalBrandingSection } from '../components/PortalBrandingSection.jsx';
import { DEFAULT_BRANDING_COLORS } from '../branding/buttonPresets.js';

export function AdminSettingsPage() {
  const [org, setOrg] = useState(null);
  const [form, setForm] = useState({});
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiJson('/api/admin/organization')
      .then((o) => {
        setOrg(o);
        setForm({
          name: o.name || '',
          button_preset: o.button_preset || 'classic',
          header_bg_color: o.header_bg_color || DEFAULT_BRANDING_COLORS.header_bg_color,
          content_bg_color: o.content_bg_color || DEFAULT_BRANDING_COLORS.content_bg_color,
          header_text_color: o.header_text_color || DEFAULT_BRANDING_COLORS.header_text_color,
          content_text_color: o.content_text_color || DEFAULT_BRANDING_COLORS.content_text_color,
          link_color: o.link_color || DEFAULT_BRANDING_COLORS.link_color,
          support_email: o.support_email || '',
          timezone: o.timezone || 'America/Toronto',
        });
      })
      .catch((e) => setError(e.message));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setMsg('');
    try {
      const updated = await apiJson('/api/admin/organization', {
        method: 'PUT',
        body: form,
      });
      setOrg(updated);
      setMsg('Saved.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (!org && !error) {
    return <p className="muted">Loading…</p>;
  }

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Organization settings</h2>
      {error ? <p className="err">{error}</p> : null}
      {msg ? <p className="muted">{msg}</p> : null}
      <form onSubmit={save} className="auth-card flat stack" data-tour="settings-branding">
        <label className="field">
          <span>Company name</span>
          <FormInput value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} />
        </label>

        <PortalBrandingSection
          form={form}
          setForm={setForm}
          logoUrl={org?.logo_url}
          onLogoChange={(url) => setOrg((prev) => (prev ? { ...prev, logo_url: url } : prev))}
        />

        <label className="field">
          <span>Support email</span>
          <FormInput
            type="email"
            value={form.support_email}
            onChange={(e) => setForm((f) => ({ ...f, support_email: e.target.value }))}
          />
        </label>
        <label className="field">
          <span>Timezone</span>
          <FormInput value={form.timezone} onChange={(e) => setForm((f) => ({ ...f, timezone: e.target.value }))} />
        </label>

        <button type="submit" className="btn-primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save'}
        </button>
      </form>
    </div>
  );
}
